document.addEventListener('DOMContentLoaded', function (){

    let personalizationTextBlock, personalizationText;

    const personalizationTriggerOptions = [
        'engraving',
        'personalization',
        'add embossing (optional)'
    ];

    const personalizationTriggerValues = [
        'engrave monogram',
        'engrave logo',
        'engrave qr-code',
        'plain embossing',
        'silver embossing',
        'gold embossing',
        'monogram',
        'logo',
        'qr-code',
        'blind',
        'silver foil',
        'gold foil'
    ];

    // personalization on product page
    if (document.querySelector('.product-section .personalization-info')){
        setPersonalization();
        selectionOptionListener();
        showSelectedOptionValue();
    }

    if (document.querySelector('.product-section')){
        setMaxProductDescription();
    }

    function setPersonalization(){
        personalizationTextBlock = document.querySelector('.personalization-info');
        personalizationText = document.querySelector('#personalization-info');
        let productOptions = document.querySelectorAll('.product-form__controls');

        productOptions.forEach(function (item){
            let optionLabel = item.querySelector('.product-form__group-label').textContent;

            if (personalizationTriggerOptions.includes(optionLabel.toLowerCase())) {
                let currentSelected = item.querySelector('input[type="radio"]:checked');
                let optionSelects = item.querySelectorAll(`input[type="radio"][name="${optionLabel}"]`);

                if (personalizationTriggerValues.includes(currentSelected.value.toLowerCase())) {
                    personalizationTextBlock.classList.add('active');
                }

                personalizationListener(optionSelects);
            } else {
                // listen another option
                let optionSelects = item.querySelectorAll(`input[type="radio"][name="${optionLabel}"]`);
                listenAnotherOption(optionSelects);
            }
        })
    }

    function listenAnotherOption(optionSelects) {
        optionSelects.forEach(function (item){
            item.addEventListener('change', function (){
                setTimeout(function (){
                    checkPersonalizationField();
                }, 100);
            })
        })
    }

    // listen change size option
    function personalizationListener(optionSelects){
        optionSelects.forEach(function (item){
            item.addEventListener('change', function (event){
                if (personalizationTriggerValues.includes(event.target.value.toLowerCase())) {
                    personalizationTextBlock.classList.add('active');
                } else {
                    personalizationTextBlock.classList.remove('active');
                    document.getElementById('personalization-text-hidden').value = '';
                    document.getElementById('personalization-info').value = '';
                }

                setTimeout(function (){
                    checkPersonalizationField();
                }, 100);
            })
        })

        // Listen personalizationText
        personalizationText.addEventListener('input', function (event) {
            checkPersonalizationField();
            document.getElementById('personalization-text-hidden').value = this.value;
        });

        checkPersonalizationField();
    }

    function isEmptyPersonalizationField() {
        if (personalizationText.value.length < 2) {
            return true;
        } else {
            return false;
        }
    }

    // disable button if field empty
    function checkPersonalizationField() {
        let buttons = document.querySelectorAll('.product-form__buttons button');

        setTimeout(function (){
            if (personalizationTextBlock.classList.contains('active')) {
                if (isEmptyPersonalizationField()) {
                    buttons.forEach(function (item){
                        item.setAttribute('disabled', 'disabled');
                        personalizationTextBlock.classList.add('error');
                    })
                } else {
                    buttons.forEach(function (item){
                        item.removeAttribute('disabled');
                        personalizationTextBlock.classList.remove('error');
                    })
                }
            }
        },600)
    }

    function selectionOptionListener() {
        let optionValueRadios = document.querySelectorAll('variant-radios input[type="radio"]');

        optionValueRadios.forEach(function (item) {
            item.addEventListener('change', function (){
                showSelectedOptionValue();
            })
        })
    }

    function showSelectedOptionValue() {
        let productOptions = document.querySelectorAll('.product-form__controls');

        productOptions.forEach(function (item){
            const showSelectedValueElement = item.querySelector('.product-form__selected-value')
            const selectedValue = item.querySelector('input[type="radio"]:checked').value;

            showSelectedValueElement.innerText = selectedValue;
        })
    }

    function setMaxProductDescription() {
        const productDescriptionBlock = document.querySelector('.product__description');
        const descriptionButtonHolder = document.querySelector('.product__description-button-holder');

        if (productDescriptionBlock.scrollHeight > 250) {
            const showMoreButton = document.createElement('button');

            showMoreButton.innerText = 'Read full description';
            showMoreButton.classList.add('product__description-show-more');

            showMoreButton.addEventListener('click', function () {
                productDescriptionBlock.classList.toggle('product__description-hidden');

                if (productDescriptionBlock.classList.contains('product__description-hidden')) {
                    showMoreButton.innerText = 'Read full description';
                } else {
                    showMoreButton.innerText = 'Hide';
                }
            });

            descriptionButtonHolder.append(showMoreButton);
            productDescriptionBlock.classList.add('product__description-hidden');
        }
    }
})